// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function noop(...args: unknown[]) {
  //
}
